import React, { useMemo } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import uniqueId from 'lodash/uniqueId';
import {
  PopperDropdownManager,
  PopperDropdownToggle,
} from '@wix/da-shared-react/pkg/Dropdown/PopperDropdownLayout';
import { useDropdownItems } from '@wix/da-shared-react/pkg/Dropdown/hooks/useDropdownItems';
import StandardDropdownMenu from '@wix/da-shared-react/pkg/Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { NullableDropdownItem } from '@wix/da-shared-react/pkg/Dropdown/types';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/24x24/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './TiersDropdown.scss';

export interface Props {
  className?: string;
  tiers: PapiDeviation[];
  selectedTier?: PapiDeviation;
  setSelectedTierId: (tierId: number) => void;
}

const TiersDropdown: React.FC<Props> = ({
  className,
  tiers,
  selectedTier,
  setSelectedTierId,
}) => {
  const id = uniqueId('tiersdropdown');
  const items: NullableDropdownItem[] = useMemo(
    () =>
      tiers
        .filter(tier => tier.isPublished)
        .map(tier => ({
          label: tier.title,
          value: tier.deviationId,
        })),
    [tiers]
  );
  const { filteredItems } = useDropdownItems(items);

  return (
    <div className={classnames(s['root'], className)}>
      <PopperDropdownManager isInPopup disabled={tiers.length === 1}>
        <PopperDropdownToggle className={s['toggle']}>
          <span>{selectedTier?.title}</span>
          {tiers.length > 1 && (
            <ArrowDownIcon className={s['caret']} size={IconSize.MEDIUM} />
          )}
        </PopperDropdownToggle>
        <StandardDropdownMenu
          id={id}
          role={'menu'}
          placement="bottom-start"
          className={s['menu']}
          items={filteredItems}
          onSelect={setSelectedTierId}
          menuScrollable
          allowFlip={false}
        />
      </PopperDropdownManager>
    </div>
  );
};
TiersDropdown.displayName = 'TiersDropdown';

export default TiersDropdown;
